
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useHistory , useLocation } from "react-router-dom";

import InputGroup from 'react-bootstrap/InputGroup';
import Alert from 'react-bootstrap/Alert';
import ButtonSpinner from '../spinners/ButtonSpinner';
import Terms from '../modals/Terms';

import RecaptchaComponent from '../RecaptchaComponent';

import { useTranslation } from 'react-i18next';

import { Formik, Field, Form, ErrorMessage } from 'formik';

import * as Yup from "yup";

import { authenticationService } from '../../services/authenticationService';
import { myListCounterService } from '../../services/myListCounterService';
import { notificationService } from '../../services/notificationService';
import { notificationsPolling } from '../../services/notificationsPolling';

import { SiteConfig }  from '../../SiteConfig';

function submitToHubSpot(name, email, organisation, jobtitle, market_segment, email_subscriptions) {
  if (!SiteConfig.isProductionEnvironment) return;
  var _hsq = window._hsq = window._hsq || [];
  var properties = {
    email: email,
    firstname: name
  };
  if (organisation) properties.organisation = organisation;
  if (jobtitle) properties.jobtitle = jobtitle;
  if (market_segment && market_segment.length) properties.market_segment = market_segment.join(';');
  if (email_subscriptions && email_subscriptions.length) properties.email_subscriptions = email_subscriptions.join(';');
  _hsq.push(["identify", properties]);
  _hsq.push(["trackPageView"]);
}

const marketSegmentOptions = [
  { value: 'defence_security', label: 'Defence & Security' },
  { value: 'humanitarian', label: 'Humanitarian' },
  { value: 'academic', label: 'Academic' },
  { value: 'infrastructure', label: 'Infrastructure' },
  { value: 'media', label: 'Media' },
  { value: 'other', label: 'Other' }
];

const emailSubscriptionOptions = [
  { value: 'monthly_situation_reports', label: 'Monthly Situation Reports (SitReps)' },
  { value: 'monthly_current_newsletters', label: 'Monthly Current, Emerging & Prolific Newsletters' },
  { value: 'bulletins', label: 'Bulletins (Paid METIS users only)' },
  { value: 'metis_updates_information', label: 'METIS Updates & Information' },
  { value: 'iris_updates_information', label: 'IRIS Updates & Information' },
  { value: 'mineaction_imas_updates', label: 'Mineaction.net & IMAS Updates' },
  { value: 'others', label: 'Other Fenix Insight products, services and offers' },
];

function RegisterForm(props) {

  const notificationsPollingMode = notificationsPolling();

  const feedbackAreaRef = useRef(null);
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const [termsShow, setTermsShow] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [reCaptchaToken, setReCaptchaToken] = useState(null);


  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // redirect to home if already logged in
     if (authenticationService.currentUserValue) {
         history.push('/');
     }
   },[history]);

  const onToken =  useCallback(async(token) => {
    setReCaptchaToken(token);
  },[setReCaptchaToken]);



  const  regenerateToken = () => {
    window.grecaptcha.ready(function() {
      window.grecaptcha
        .execute(SiteConfig.recapchaV3SiteKey, { action: "registerform" })
        .then(token => {
          onToken(token)
        });
    })
  };

  setInterval(function(){regenerateToken();}, 90*1000);


  const toggleTermsShow = () => setTermsShow(!termsShow);

  return (
    <Formik
            initialValues={{
                name: '',
                email: '',
                password: '',
                confirm_password: '',
                organisation_name: '',
                job_level: '',
                market_segment: [],
                email_subscription: [],
                accept_terms: false,
                sign_up: false
            }}
            validationSchema={Yup.object().shape({
                name: Yup.string()
                  .required(t('Please enter your name')),
                email: Yup.string()
                    .email(t('Email is invalid'))
                    .required(t('Please enter your email address')),
                password: Yup.string()
                    .min(6, t('Password must be at least 6 characters'))
                    .required(t('Password is required')),
                confirm_password: Yup.string()
                  .oneOf([Yup.ref('password'), null], t('Passwords must match')),
                job_level: Yup.string()
                  .required(t('Please enter your job title')),
                market_segment: Yup.array()
                  .min(1, t('Please select at least one industry sector')),
                accept_terms: Yup.bool().oneOf([true], t('Please accept the Terms & Conditions'))
                })}
            onSubmit={fields => {

              setFeedbackText('');

              setSubmitting(true);
              // Fetch the accessToken from the server
              authenticationService.register(fields.name, fields.email, fields.password, reCaptchaToken, fields.sign_up, SiteConfig.siteTag, fields.organisation_name, fields.job_level, fields.market_segment, fields.email_subscription )
                  .then(
                      user => {
                          setSubmitting(false);
                          myListCounterService.getMyListCount();
                          notificationService.getNotifications()
                          //start the notifications polling
                          notificationsPollingMode.running = true;
                          submitToHubSpot(fields.name, fields.email, fields.organisation_name, fields.job_level, fields.market_segment, fields.email_subscription);
                          const { from } = location.state || { from: { pathname: "/" } };
                          history.push(from);

                      },
                      error => {

                          setSubmitting(false);
                          setFeedbackText(t('Register error. If you already have an account using this email please try logging in') + '.');
                          window.scrollTo({top: feedbackAreaRef.current.getBoundingClientRect().bottom, behavior: "smooth"});
                          regenerateToken();
                          //setValidated(false);
                      }
                  );
            }}
            >
            {({ errors, status, touched }) => (

                <>
                {feedbackText && <Alert ref={feedbackAreaRef} variant="danger">
                  {feedbackText}
                </Alert>}

                <Form  id={SiteConfig.siteTag + '-account-registration-form'}>
                <div className="form-group">
                    <label htmlFor="name">{t('Name')}</label>
                    <InputGroup>
                      <InputGroup.Prepend>
                        <InputGroup.Text id="inputGroupPrepend"><i className="fa fa-user-circle" aria-hidden="true"></i></InputGroup.Text>
                      </InputGroup.Prepend>
                      <Field
                        name="name"
                        id="name"
                        type="text"
                        className={'form-control' + (errors.name && touched.name ? ' is-invalid' : '')}
                         placeholder={t('Enter name')}
                       />
                      <ErrorMessage name="name" component="div" className="invalid-feedback" />
                    </InputGroup>
                </div>
                  <div className="form-group">
                      <label htmlFor="email">{t('Email address')}</label>
                      <InputGroup>
                        <InputGroup.Prepend>
                          <InputGroup.Text id="inputGroupPrepend"><i className="fa fa-envelope" aria-hidden="true"></i></InputGroup.Text>
                        </InputGroup.Prepend>
                        <Field
                          name="email"
                          id="email"
                          type="text"
                          className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')}
                           placeholder={t('Enter email')}
                         />
                        <ErrorMessage name="email" component="div" className="invalid-feedback" />
                      </InputGroup>
                  </div>
                  <div className="form-group">
                      <label htmlFor="password">{t('Password')}</label>
                      <InputGroup>
                        <InputGroup.Prepend>
                          <InputGroup.Text id="inputGroupPrepend"><i className="fa fa-lock" aria-hidden="true"></i></InputGroup.Text>
                        </InputGroup.Prepend>
                        <Field
                          name="password"
                          id="password"
                          type="password"
                          className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')}
                          placeholder={t('Password')}
                         />
                        <ErrorMessage name="password" component="div" className="invalid-feedback" />
                      </InputGroup>
                  </div>
                  <div className="form-group">
                      <label htmlFor="confirm_password">{t('Confirm Password')}</label>
                      <InputGroup>
                        <InputGroup.Prepend>
                          <InputGroup.Text id="inputGroupPrepend"><i className="fa fa-lock" aria-hidden="true"></i></InputGroup.Text>
                        </InputGroup.Prepend>
                        <Field
                          name="confirm_password"
                          id="confirm_password"
                          type="password"
                          className={'form-control' + (errors.confirm_password && touched.confirm_password ? ' is-invalid' : '')}
                          placeholder={t('Confirm Password')}
                         />
                        <ErrorMessage name="confirm_password" component="div" className="invalid-feedback" />
                      </InputGroup>
                  </div>
                  <div className="form-group">
                      <label htmlFor="organisation_name">{t('Organisation')} <small className="text-muted">({t('optional')})</small></label>
                      <Field
                        name="organisation_name"
                        id="organisation_name"
                        type="text"
                        className="form-control"
                        placeholder={t('Enter organisation name')}
                      />
                  </div>
                  <div className="form-group">
                      <label htmlFor="job_level">{t('Job Title')}</label>
                      <Field
                        name="job_level"
                        id="job_level"
                        type="text"
                        className={'form-control' + (errors.job_level && touched.job_level ? ' is-invalid' : '')}
                        placeholder={t('Enter job title')}
                      />
                      <ErrorMessage name="job_level" component="div" className="invalid-feedback" />
                  </div>
                  <div className="form-group">
                      <label>{t('Which industry sector do you work in?')}</label>
                      <div role="group" className={errors.market_segment && touched.market_segment ? 'is-invalid' : ''}>
                        {marketSegmentOptions.map(option => (
                          <div className="form-check" key={option.value}>
                            <Field type="checkbox" name="market_segment" id={`market_segment_${option.value}`} value={option.value} className="form-check-input" />
                            <label htmlFor={`market_segment_${option.value}`} className="form-check-label">{t(option.label)}</label>
                          </div>
                        ))}
                      </div>
                      <ErrorMessage name="market_segment" component="div" className="invalid-feedback d-block" />
                  </div>
                  <div className="form-group mt-3">
                      <label>{t('Please select which emails you would like to receive from Fenix Insight')}</label>
                      <div role="group">
                        {emailSubscriptionOptions.map(option => (
                          <div className="form-check" key={option.value}>
                            <Field type="checkbox" name="email_subscription" id={`email_subscription_${option.value}`} value={option.value} className="form-check-input" />
                            <label htmlFor={`email_subscription_${option.value}`} className="form-check-label">{t(option.label)}</label>
                          </div>
                        ))}
                      </div>
                  </div>
               
                  <div className="form-group form-check mt-2 mb-4">
                      <Field type="checkbox" id="accept_terms" name="accept_terms" className={'form-check-input ' + (errors.accept_terms && touched.accept_terms ? ' is-invalid' : '')} />
                      <label htmlFor="accept_terms" className="form-check-label">{t('I agree to the')} <span className="blue pointer underline" onClick={(e)  => {e.preventDefault();toggleTermsShow()}}>{t('Terms & Conditions')}</span></label>
                      <ErrorMessage name="accept_terms" component="div" className="invalid-feedback" />
                  </div>
                  <div className="form-group">
                    <button type="submit" className="btn btn-primary mr-2" disabled={submitting || !reCaptchaToken}>{t('Create Account')}  {submitting && <ButtonSpinner/>}</button>
                  </div>
              </Form>
              <RecaptchaComponent action="registerform" onToken={onToken} sitekey={SiteConfig.recapchaV3SiteKey}/>
              <Terms show={termsShow} handleClose={toggleTermsShow}/>
              <p>
              <Link
                to="/forgotten-password"
              >{t('Forgot your password?')}</Link>
              </p>
              <div className="row">
                <div className="form-group text-center col-md-12">
                  <small>{t('This site is protected by reCAPTCHA and Google')}&nbsp;
                      <a target="_blank" rel="noreferrer" href="https://policies.google.com/privacy">{t('Privacy Policy')}</a> {t('and')}&nbsp;
                      <a target="_blank" rel="noreferrer" href="https://policies.google.com/terms">{t('Terms of Service')}</a> {t('apply')}.
                  </small>
                </div>
              </div>
              </>
            )}
       </Formik>



  );
};

export default RegisterForm;
